import { useState } from 'react';
import { CHART_FILTER_OPTIONS } from '../../constants/settings';
import DashboardSectionLayout from '../../layouts/DashboardSectionLayout';
import FilterButton from '../CommonComps/Buttons/FilterButton';
import AcademiaAreaChart from '../CommonComps/Charts/AcademiaAreaChart';

const data = [
  {
    name: 'January',
    clients: 4000,
  },

  {
    name: 'February',
    clients: 3000,
  },

  {
    name: 'March',
    clients: 2000,
  },

  {
    name: 'April',
    clients: 2780,
  },

  {
    name: 'May',
    clients: 1890,
  },

  {
    name: 'June',
    clients: 2390,
  },

  {
    name: 'July',
    clients: 3490,
  },

  {
    name: 'August',
    clients: 5490,
  },

  {
    name: 'September',
    clients: 4430,
  },

  {
    name: 'October',
    clients: 3420,
  },

  {
    name: 'November',
    clients: 4567,
  },

  {
    name: 'December',
    clients: 5508,
  },
];

const ClientSummary = () => {
  // integration of react hooks here
  const [selectedButtonId, setSelectedButtonId] = useState<number>(1);

  // rendering client summary section component here
  return (
    <DashboardSectionLayout sectionTitle='Client Summary'>
      <div className='flex items-center gap-2 px-2 py-3 rounded-lg shadow-academia-sm w-fit mb-5 mx-auto md:mx-0 md:ml-auto'>
        {CHART_FILTER_OPTIONS.map((option) => (
          <FilterButton
            key={option.id}
            keyId={option.id}
            onClick={setSelectedButtonId}
            selectedValue={selectedButtonId}
            btnText={option.label}
            layoutId='chart-underline'
            color={option.color}
            width={100}
          />
        ))}
      </div>

      <div className='w-full overflow-auto'>
        <div className='min-w-[700px] h-[500px]'>
          <AcademiaAreaChart
            data={data}
            xAxisDataKey='name'
            chartDataKey='clients'
          />
        </div>
      </div>
    </DashboardSectionLayout>
  );
};

export default ClientSummary;
